import Checkbox from '@components/Checkbox';
import CheckboxLI from '@components/CheckboxLI';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useAgreement from './hooks/useAgreement';

function Agreements() {
    const { t } = useTranslation('signUp');
    const {
        isAllChecked, agreeAll,
        termCategories, toggleTermCategory, isChecked,
    } = useAgreement();
    const { push } = useFlow();
    return (
        <Container as='section' spacing={12} fullWidth >
            <Text size='xl' fontWeight='bold'>
                {t('agreements.title')}
            </Text>
            <Column spacing={6} fullWidth>
                <All>
                    <Checkbox isChecked={isAllChecked}
                        onClick={agreeAll} >
                        {t('agreements.agreeAll')}
                    </Checkbox>
                </All>
                {termCategories.map((termCategory) => (
                    <CheckboxLI isChecked={isChecked(termCategory.id)}
                        key={termCategory.id}
                        required={termCategory.isRequired}
                        onClick={() => push('TermDetailActivity', { termCategoryId: termCategory.id })}
                        toggleCheckbox={() => toggleTermCategory(termCategory.id)}>
                        {termCategory.title}
                    </CheckboxLI>
                ))}
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 42px 20px 36px;
`;

const All = styled.div`
    padding: 6px 0;
    width: 100%;
`;

export default Agreements;
